import React from 'react';
import { Empty } from 'antd';

const NoContent = (props) => {
    return <Empty className={props.className} description={props.description} />
};

export default NoContent;